import { useEffect, useState } from "react";
import Button from "./Button";
import Text from "../../../../components/ui/Text";
import { useTalkieWalkie } from "../../hooks/use-talkie-walkie";

interface Props {
  className?: string;
  placeholder?: string;
  buttonTitle?: string;
  value?: string;
  onChange?: (value: string) => void;
  onConnect?: () => void;
}

const RadioInput = ({
  className = "",
  placeholder = "Input information here",
  onChange = () => {},
  onConnect = () => {},
  buttonTitle = "Connect",
  value: valueFromProps,
}: Props) => {
  const [value, setValue] = useState<string>("");
  const { connectToChannel } = useTalkieWalkie();

  useEffect(() => {
    if (valueFromProps !== undefined) setValue(valueFromProps);
  }, [valueFromProps]);

  return (
    <div className={`${className}`}>
      <input
        type="text"
        className="bg-[#161820] border-0 outline-0 rounded-md p-2 placeholder:text-[12px] placeholder:text-[#BEB9FF8C]/30 text-white/70 text-[13px] w-full"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      />
      <Button
        variant="blue"
        disableAudioEffect
        className="mt-2 rounded-md"
        onClick={() => {
          if (!value) return;

          connectToChannel({ id: "1", mhz: +value, name: "Channel" });
          onConnect();
        }}
      >
        <Text className="text-white text-center !font-[400]" size="xxs">
          {buttonTitle}
        </Text>
      </Button>
    </div>
  );
};

export default RadioInput;
